export default __webpack_public_path__ + "static/5-c1a4bc34590dc1a403917410f3567896.jpeg";